// extracted by mini-css-extract-plugin
export default {"listContainer":"areaAssignments_listContainer__BnnD6","sectionHeader":"areaAssignments_sectionHeader__ZrA6v","areaBlock":"areaAssignments_areaBlock__TWbsl"};